<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M14 3L6.8 13L2 8" stroke="#8E9AC7" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
